import { getRandomId } from 'framework-ui-components/Components/Utils/baseComponentHelper';
import { callChild } from './forward';
import { PluginCallsTypes } from './constants';
import Log from '../utils/log';
import { isPresentIFrame } from './caller';

const EventOriginCheck = 'fw-plugins-clickOut-event';

let lastObjectOutside = null;
let lastEventOutsideId;

/** Metodo che tiene in sospeso un evento e lo sblocca in base al
 * risultato dell'evento IS_CLICKABLE_OUTSIDE del child */
const eventFilter = (event) => {
  if (isPresentIFrame() && event.originCheck !== EventOriginCheck) {
    event.preventDefault();
    event.stopPropagation();
    lastObjectOutside = event;
    lastEventOutsideId = getRandomId();
    callChild(PluginCallsTypes.IS_CLICKABLE_OUTSIDE, null, lastEventOutsideId)
      .then((isClickableOutside) => {
        if (isClickableOutside) {
          eventFilterOk(event);
        }
      })
      .catch(() => {
        Log.error(`Non sembra sia gestita la chiamata "${PluginCallsTypes.IS_CLICKABLE_OUTSIDE}"`);
        eventFilterOk(event);
      });
    return true;
  }
  return false;
};

/** riattivazione di un evento precedentemente stoppato */
const eventFilterOk = (event) => {
  const originaEvent = new event.constructor(event.type, event);
  originaEvent.originCheck = EventOriginCheck;
  const origEvent = (event.path && event.path[0]) || event.explicitOriginalTarget || event.srcElement;
  origEvent.dispatchEvent(originaEvent);
};

const functFilter = (funct) => {
  if (isPresentIFrame()) {
    lastObjectOutside = funct;
    lastEventOutsideId = getRandomId();
    callChild(PluginCallsTypes.IS_CLICKABLE_OUTSIDE, null, lastEventOutsideId)
      .then((isClickableOutside) => {
        if (isClickableOutside) {
          funct();
        }
      })
      .catch(() => {
        Log.error(`Non sembra sia gestita la chiamata "${PluginCallsTypes.IS_CLICKABLE_OUTSIDE}"`);
        funct();
      });
  } else {
    funct();
  }
};

/** se il child manda un messaggio di restore dell'evento/function allora viene verificato
 * che l'id dello stesso corrisponda all'ultimo e in questo caso si riattiva
 * nel parent */
const restoreLastOutside = (lastEventId) => {
  if (lastObjectOutside && lastEventOutsideId === lastEventId) {
    if (typeof lastObjectOutside === 'function') {
      lastObjectOutside();
    } else {
      eventFilterOk(lastObjectOutside);
    }
    lastObjectOutside = null;
  }
};

export {
  EventOriginCheck,
  eventFilter,
  functFilter,
  restoreLastOutside,
};
